import { render, staticRenderFns } from "./success_resp.vue?vue&type=template&id=22140ff3"
import script from "./success_resp.vue?vue&type=script&lang=js"
export * from "./success_resp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports